import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link as ReactLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'underscore';

import {
    Title,
    Link,
    Icon,
} from 'yurstrap';

import { buildQueryParameters } from 'helpers/RoutesHelpers';
import Routes from '../../constants/Routes';

import { getCookieSelector } from '../../reduxModules/ConsentManagementPlatform';

const propTypes = {
    cookie: PropTypes.object.isRequired,
};

export class CMPCookieDetails extends Component {

    renderCookiesNames() {
        const { cookie } = this.props;
        const { cookiesNames } = cookie;
        return _.map(cookiesNames, (cookieName) => (
            <p key={cookieName}>
                { cookieName }
            </p>
        ));
    }

    render() {
        const { cookie } = this.props;
        const params = {
            'cmp-modal': Routes.COOKIES_LIST.link,
        };
        const queryParams = buildQueryParameters(params);
        return (
            <>
                <Link
                    className="u-color__grey--60"
                    componentClass={ReactLink}
                    to={{
                        search: `?${queryParams}`,
                        state: { collapsed: false },
                    }}
                >
                    <Icon icon="chevron-left mr-1" />
                    Retour
                </Link>
                <Title
                    componentClass="h6"
                    className="mt-4"
                >
                    Cookies déposés par
                    {' '}
                    {cookie.title}
                </Title>
                {this.renderCookiesNames()}
            </>
        );
    }

}

CMPCookieDetails.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
    return {
        cookie: getCookieSelector(state, ownProps.match.params.cookieId.toUpperCase()),
    };
}

export default connect(
    mapStateToProps,
)(CMPCookieDetails);
